/**
 * The PointCraft platform composition root.
 *
 * Ask capability questions here instead of platform questions. See
 * `docs/electron-phase1/PLAN.md` §4 and AMENDMENT A3, and
 * `docs/electron-phase1/SITE_TRIAGE.md` for the sites deliberately left
 * un-migrated.
 */
import { getRuntime } from './runtime';
import type { RuntimeCapabilities } from './types';

export { RUNTIME_CAPABILITIES } from './capabilities';
export { getRuntime, detectRuntimeKind } from './runtime';
export {
  UnknownRuntimeError,
  ElectronBridgeUnavailableError,
  PlatformCapabilityUnsupportedError,
} from './errors';
export {
  RUNTIME_KINDS,
  isRuntimeKind,
  type PosRuntime,
  type RuntimeKind,
  type RuntimeCapabilities,
  type RuntimeCapabilityKey,
} from './types';

/** Read one cell of the current runtime's capability row. */
export function hasCapability<K extends keyof RuntimeCapabilities>(key: K): RuntimeCapabilities[K] {
  return getRuntime().capabilities[key];
}

/** iOS or Android. NOT the same question as `isNativeRuntime()` — see A3.2. */
export function isMobileRuntime(): boolean {
  return getRuntime().isMobile;
}

/** A packaged install (mobile app or Electron shell), i.e. not a browser tab. */
export function isNativeRuntime(): boolean {
  return getRuntime().isNative;
}

/** The Electron desktop shell. */
export function isDesktopShellRuntime(): boolean {
  return getRuntime().isDesktopShell;
}
